var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#F2F3FC",
    transform: "translate(-67 -239) translate(67 239)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 9
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#050849",
    strokeWidth: 2,
    d: "M19 25c-.828 0-1.578.336-2.121.879C16.336 26.422 16 27.172 16 28c0 .544.098.937.434 1.15.57.359 1.464.37 2.566.37 1.102 0 1.996-.011 2.566-.37.336-.213.434-.606.434-1.15 0-.828-.336-1.578-.879-2.121C20.578 25.336 19.828 25 19 25z",
    transform: "translate(-67 -239) translate(67 239)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#050849",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8 14.5L14 13M24 13L29.601 14.5",
    transform: "translate(-67 -239) translate(67 239)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.413d4401.svg";
export { ForwardRef as ReactComponent };